import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { startCase } from "lodash";

import MyAccountLayout from "./MyAccountLayout";
import CustomDatePicker from "../../components/CustomDatePicker";
import MyAccountFilter from "./MyAccountFilter";
import Pagination from "../../components/Pagination";
import { apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { formatDate, toFixedWithoutRounding } from "../../Utils/Constant";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useParams } from "react-router-dom";

const legLabel = (count) =>
  count === 1 ? "Single" : count === 2 ? "Double" : count === 3 ? "Treble" : count > 3 ? "Accumulator" : "";

const ParlayBetHistory = () => {
  const params = useParams();
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const tableRef = useRef();

  const DEFAULT_FILTER = {
    page: 1,
    limit: 10,
    betType: "parlay",
    userType: params?.type,
    id: params?.id,
    fromPeriod: moment().subtract(1, "day").format("YYYY-MM-DD HH:mm:ss"),
    toPeriod: moment().format("YYYY-MM-DD HH:mm:ss"),
  };

  const [filter, setFilter] = useState(DEFAULT_FILTER);
  const [data, setData] = useState({});
  const [openRows, setOpenRows] = useState({});

  const getData = async (activeFilter) => {
    const { status, data: response_users } = await apiGet(apiPath.betHistory, activeFilter);
    if (status === 200 && response_users.success) {
      setData(response_users.results);
    }
  };

  useEffect(() => {
    getData(filter);
  }, [filter.page, filter.limit]);

  const handleLimitChange = (e) => setFilter((prev) => ({ ...prev, limit: Number(e.target.value), page: 1 }));

  const handlePageChange = (newPage) => setFilter((prev) => ({ ...prev, page: newPage }));

  const applyPreset = (preset) => {
    const fromPeriod = preset === "today" ? moment().startOf("day") : moment().subtract(1, "day").startOf("day");
    const toPeriod = preset === "today" ? moment().endOf("day") : moment().subtract(1, "day").endOf("day");
    const nextFilter = {
      ...filter,
      page: 1,
      fromPeriod: fromPeriod.format("YYYY-MM-DD HH:mm:ss"),
      toPeriod: toPeriod.format("YYYY-MM-DD HH:mm:ss"),
    };
    setFilter(nextFilter);
    if (filter.page === nextFilter.page) getData(nextFilter);
  };

  const toggleRow = (id) => setOpenRows((prev) => ({ ...prev, [id]: !prev[id] }));

  const rows = data?.data || [];

  const totalPL = rows.reduce((sum, item) => {
    if (!item?.isDeclared) return sum;
    return sum + (item.result === "loss" ? -Number(item?.loseAmount || 0) : Number(item?.profitAmount || 0));
  }, 0);

  return (
    <MyAccountLayout>
      <div id="report" className="col-center report">
        <div className="box" style={{ alignItems: "baseline" }}>
          <h3 style={{ fontSize: "24px", marginTop: "20px", marginBottom: "10px" }}>
            Parlay Betting History
          </h3>
        </div>

        <div className="function-wrap">
          <ul className="input-list">
            <li>
              <label>Period</label>
            </li>
            <CustomDatePicker filter={filter} setFilter={setFilter} />
          </ul>
          <ul className="input-list flowroot">
            <li>
              <a
                id="today"
                className="btn"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  applyPreset("today");
                }}
              >
                Just for today
              </a>
            </li>
            <li>
              <a
                id="yesterday"
                className="btn"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  applyPreset("yesterday");
                }}
              >
                From yesterday
              </a>
            </li>
            <li>
              <a
                id="getPL"
                className="btn-send"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  getData(filter);
                }}
              >
                Get P &amp; L
              </a>
            </li>
          </ul>
        </div>

        <div id="userTreeDiv" className="total_all">
          <span className="total-users" style={{ fontSize: "15px", fontWeight: "700" }}>
            {" "}
            Total Pnl:{" "}
            <strong className={totalPL < 0 ? "loss-text" : "profit-text"}>
              {toFixedWithoutRounding(totalPL)}
            </strong>
          </span>
          <span className="spacer" />
          <div>
            <span>
              <label>Last:</label>
              <select name="limit" id="limit" value={filter.limit} onChange={handleLimitChange}>
                 <option value={10}>10 Txn</option>{" "}
              <option value={25}>25 Txn</option>{" "}
              <option value={50}>50 Txn</option>
              <option value={100}>100 Txn</option>
              </select>
            </span>
          </div>
          <MyAccountFilter type={"new"} tableRef={tableRef} fileName={"parlay-betting-history"} />
        </div>

        <div id="reportTable">
          <div className="table-responsive data-table" style={{ overflow: "auto", whiteSpace: "nowrap" }}>
            <table ref={tableRef} id="table_DL" className="table-s" style={{ display: "table" }}>
              <tbody>
                <tr>
                  <th width="10%" className="align-L sort_asc">Bet ID</th>
                  <th width="8%" className="align-L sort_asc">Event</th>
                  <th width="8%" className="align-L sort_asc">Bet Placed</th>
                  <th width="8%" className="align-L sort_asc">Bet Settled</th>
                  <th width="8%" className="sort_asc">Stake</th>
                  <th width="10%" className="sort_asc">Profit/Loss</th>
                </tr>

                {rows.length > 0 ? (
                  rows.map((item, index) => {
                    const rowId = item?._id || item?.matchBetId || index;
                    const isOpen = !!openRows[rowId];

                    return (
                      <React.Fragment key={rowId}>
                        <tr style={{ display: "table-row" }}>
                          <td className="align-L">{item?.matchBetId}</td>

                          <td className="align-L">
                            Parlay
                            <img id="arrow" src="/assets/images/transparent.gif" className="fromto" alt="" />
                            <strong>{legLabel(item?.bets?.length)}</strong>
                          </td>

                          <td className="align-L">{formatDate(item?.timeInserted, user?.timeZone)}</td>

                          <td className="align-L">
                            {item?.isDeclared ? formatDate(item?.settledDate || item?.updatedAt, user?.timeZone) : "-"}
                          </td>

                          <td>{item?.amount}</td>

                          <td>
                            <a
                              style={{ float: "right", paddingRight: "20px" }}
                              className={!isOpen ? "expand-close" : "expand-open"}
                              onClick={() => toggleRow(rowId)}
                            >
                              {item?.isDeclared ? (
                                <span className={item?.result === "loss" ? "red" : "green"}>
                                  {item?.result === "loss"
                                    ? `-${toFixedWithoutRounding(item?.loseAmount)}`
                                    : toFixedWithoutRounding(item?.profitAmount)}
                                </span>
                              ) : (
                                <span>...</span>
                              )}
                            </a>
                          </td>
                        </tr>

                        {item?.bets?.length > 0 && isOpen && (
                          <tr className="expand" style={{ display: "table-row" }} id={`sub_${rowId}`}>
                            <td colSpan="6">
                              <img src="/assets/images/transparent.gif" className="expand-arrow-R" alt="" />

                              <table className="table-commission">
                                <tbody>
                                  <tr>
                                    <th className="align-L">Sport</th>
                                    <th className="align-L">Event</th>
                                    <th className="align-L">Market</th>
                                    <th className="align-L">selName</th>
                                    <th className="align-L">Bet taken</th>
                                    <th className="align-L">Type</th>
                                    <th className="align-L">Odds</th>
                                    <th className="align-L">Result</th>
                                  </tr>

                                  {item.bets.map((betData, i) => (
                                    <tr key={i} className="align-L even">
                                      <td>
                                        {betData?.eventType === "4"
                                          ? "Cricket"
                                          : betData?.eventType === "1"
                                            ? "Soccer"
                                            : betData?.eventType === "2"
                                              ? "Tennis"
                                              : "Sports"}
                                      </td>
                                      <td>{betData?.matchName}</td>
                                      <td>{betData?.fancyName}</td>
                                      <td>{betData?.runnerName}</td>
                                      <td>
                                        <span id="betPlaced" className="small-date">
                                          {formatDate(betData?.timeInserted, user?.timeZone)}
                                        </span>
                                      </td>
                                      <td>
                                        <span className={betData?.betType === "lay" ? "lay" : "back"}>
                                          {startCase(betData?.betType)}
                                        </span>
                                      </td>
                                      <td>{toFixedWithoutRounding(betData?.bhav)}</td>
                                      <td>
                                        {betData?.isDeclared ? (betData?.result === "loss" ? "LOST" : "WON") : "..."}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={6}>You have no bets in this time period.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {rows.length > 0 && data?.totalDocs > 0 && (
            <Pagination pagination={data} onPageChange={handlePageChange} />
          )}
        </div>
      </div>
    </MyAccountLayout>
  );
};

export default ParlayBetHistory;
